<template>
  <div>
    <div :style="{width: width,height: height,lineHeight: lineHeight}" class="nameCircle text-lightBlue">{{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: "NameIcon",
  props: ['title', 'width', 'lineHeight', 'height'],
}
</script>

<style scoped>
.nameCircle {
  border: 2px solid #0D4370;
  background-color: #062C4F;
  width: 55px;
  height: 55px;
  line-height: 52px;
  border-radius: 50%;
  text-align: center;
  margin: auto;
}
</style>
